<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <EditOffice />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import EditOffice from "./components/EditOffice";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "Users",
  components: {
    EditOffice,
    // ProjectsTable,
  },
};
</script>
